import script from "./CardTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./CardTemp.vue?vue&type=script&setup=true&lang=js"

import "./CardTemp.vue?vue&type=style&index=0&id=a4b66f7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4b66f7a"]])

export default __exports__